<template>
  <div>
  <vs-table
    v-if="show"
    :params="params"
    :options="options"
    @onCreateHeaderActionClicked="openOrderDetail('create',0,2)"
  ></vs-table>

  </div>
</template>

<script>
  import VsTable from "../_framework/VsTable.vue";
  import BaseService from "../_framework/api/BaseService.js";
  import { mapState, mapMutations, mapActions } from "vuex";
  export default {
    name: "purchase-order",
    created: () => {},
    components: {
      VsTable
    },
    data() {
      return {
        show: true,
        access: {},
        params: {
          // reqUrl:"/type=1",
          entity: "orders",
          extraParameters :{
            type:2
          },
          list: [],
          headers: {
            code: {
              title: "کد",
              type: "text",
              rowAlignment: "center"
            },
            receiverName: {
              title: "سفارش دهنده",
              type: "text",
              rowAlignment: "center"
            },
            serveName: {
              title: "تامین کننده",
              type: "text",
              rowAlignment: "center"
            },
            description: {
              title: "توضیحات سفارش",
              type: "text",
              rowAlignment: "center"
            },
            date: {
              title: "تاریخ سفارش",
              type: "text",
              rowAlignment: "center",
              formatGregorianDateToJalaali: true
            }
          }
        },
        options: {
          hasActions: true,
          hasActionsInHeader: true,
          clickableRows: true,
          isPrintable:true,
          onCreateHeaderActionClicked: true,
          onEditClicked: (row, context) => {
            this.openOrderDetail("edit", row.id,2);
          },
          onRowDoubleClicked: row => {
            this.openOrderDetail("view", row.id,2);
          },
          onPrintClicked: (row, context) => {
            this.goToPrintPage(row);
          },

          getTopRightButtons: () => {
            let arr = [];
            let searchToggleButton = {
              component: "search-toggle-button"
            };
            arr.push(searchToggleButton);
            return arr;
          },
          getTopLeftButtons: () => {
            let arr = [];
            let self = this;
            let addItemButton = {
              component: "toggle-table-actions-button",
              params: {
                onClick() {
                  self.options.hasActions = !self.options.hasActions;
                }
              }
            };
            arr.push(addItemButton);
            return arr;
          }
        }
      };
    },
    methods: {
      goToPrintPage(row) {
        this.$router.push(
          {
            name: "پرینت سفارش",
            params: {
              id: row.id,
              isBuyOrder :true

            }
          }
        );
      },
      openOrderDetail(_mode, id, type) {
        this.$store.commit("REMOVE_ALL_ROWS_FROM_VS_TABLE_FEED");
        this.$router.push({
          path: "/purchase-order-detail",
          query: { id, _mode , type}
        });
      }
    },
    beforeMount() {
      this.options.access = checkAccess(this.$route.path);
      // console.log(this.options.access);
      // console.log("sa;;a;");

      this.show = !!this.options.access;

    },
    computed: {
      ...mapState(["vsTableFeed", "tableRowIndex"])
    }
  };
</script>
